import { z } from "zod";

/**
 * ReportRateioGeralSchema
 */


export const ReportRateioGeralSchema = z.object({
    requiredMimeType: z.string().optional().nullable(),
    numeroConta: z.string().optional().nullable(),
    centroCustos: z.array(z.number()).nullable().default(null),
    fornecedores: z.array(z.number()).nullable().default(null),
    ordemCompras: z.array(z.number()).nullable().default(null),
    medicoes: z.array(z.number()).nullable().default(null),
    funcionarios: z.array(z.number()).nullable().default(null),
    valorPago: z.preprocess(
        (val) => (val === "" || val === undefined || val === null ? null : Number(val)),
        z.number().optional().nullable()
    ),
    dataDe: z.coerce.date().optional().nullable(),
    dataAte: z.coerce.date().optional().nullable(),
    idUsuario: z.number().int().optional().nullable(),

});


/**
 * ReportRateioGeralForm
 */

export type ReportRateioGeralForm = z.infer<typeof ReportRateioGeralSchema>;

export const defaultReportRateioGeralForm: ReportRateioGeralForm = {
    centroCustos: null,
    fornecedores: null,
    ordemCompras: null,
    medicoes: null,
    funcionarios: null,
    dataDe: null,
    dataAte: null,
    idUsuario: null,
    numeroConta: null,
    requiredMimeType: null,
    valorPago: null,

};